import Modal from '@/components/modal/Modal';
import { MemberReviewDetailResponse, useMemberReviewDetail } from '@/features/centerReview';
import { colors } from '@/lib/colors';
import { RegularText } from '@/lib/Text';
import { Col } from '@/lib/utils';
import React, { useState, useEffect } from 'react';
import ModalMemberReviewHeader from './ModalMemberReviewHeader';
import ModalMemberReviewContent from './ModalMemberReviewContent';

type Props = {
    unmount?: () => void;
    reviewId: string;
};

const stageLabelMap: Record<string, string> = {
    first_class: '첫회차',
    middle_class: '중간회차',
    final_class: '마지막회차',
};

function ModalMemberReview({ unmount, reviewId }: Props) {
    const [currentReviewId, setCurrentReviewId] = useState(reviewId);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    const { data, isLoading } = useMemberReviewDetail({
        reviewId: currentReviewId,
        enabled: !!currentReviewId,
    });

    useEffect(() => {
        const handleResize = () => setWindowHeight(window.innerHeight);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const detail = data as MemberReviewDetailResponse | undefined;

    const handleClose = () => {
        if (unmount) unmount();
    };

    const handlePrev = () => {
        if (detail?.prevReviewId) {
            setCurrentReviewId(detail.prevReviewId);
        }
    };

    const handleNext = () => {
        if (detail?.nextReviewId) {
            setCurrentReviewId(detail.nextReviewId);
        }
    };

    const reviewStageLabel = detail?.reviewStage ? stageLabelMap[detail.reviewStage] || detail.reviewStage : '-';

    return (
        <Modal onClose={handleClose} isCloseButton borderRadius={35} whiteViewHeight={windowHeight - 100}>
            <Col className="w-[896px] h-[calc(100vh-100px)] overflow-y-auto p-[32px]">
                {isLoading && (
                    <div className="flex items-center justify-center py-[80px]">
                        <RegularText fontSize={16} lineHeight={21} color={colors.Text_2}>
                            불러오는 중...
                        </RegularText>
                    </div>
                )}
                {!isLoading && !detail && (
                    <div className="flex items-center justify-center py-[80px]">
                        <RegularText fontSize={16} lineHeight={21} color={colors.Text_2}>
                            리뷰 정보를 불러오지 못했어요.
                        </RegularText>
                    </div>
                )}
                {!isLoading && detail && (
                    <Col className="flex w-full">
                        <ModalMemberReviewHeader detail={detail} />
                        <Col className="w-full h-[1px] bg-[#E5E5E5] mt-[25px] " />
                        <ModalMemberReviewContent
                            detail={detail}
                            reviewStageLabel={reviewStageLabel}
                            handlePrev={handlePrev}
                            handleNext={handleNext}
                        />
                    </Col>
                )}
            </Col>
        </Modal>
    );
}

export default ModalMemberReview;
